let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2shw0")).then(() => parcelRequire('26Elb'));